import { initI18n } from "@/i18n";

// Dil dosyası yüklendikten sonra uygulama modülleri açılır (modül düzeyindeki metinler de doğru dilde oluşur)
initI18n().finally(() => import("@/bootstrap"));
